import { render, staticRenderFns } from "./IconHubspot.vue?vue&type=template&id=54d8c9b9&"
import script from "./IconHubspot.vue?vue&type=script&lang=ts&"
export * from "./IconHubspot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports